import Vue from 'vue';
import MathJax from '@/commons/components/MathJax.vue'

export default Vue.component('DocumentText', {
    props: {
        text: String,
        docType: String,
        hostingName: String
    },
    render(h, context) {
        let _text = this.docType === 'ScienceOpenAlex' ? this.text.replace(/&\slt;/g, '&lt;')
            .replace(/&\sgt;/g, '&gt;')
                .replace(/(&lt;)([\w\s"/=']+)(&gt;)/g, '<$2>')
                // .replace(/<\s/g, '<')
                // .replace(/(\w)\s>/g, '$1>')
                // .replace(/<\w*\/\s*(\w+)>/g, '</$1>')
                // .replace(/\s&amp;\s(\w+;)\s/g, ' &$1 ')
            : this.text;
        // let _text = this.text;
        if(this.docType !== 'Science') {
            return h('span', {domProps: {innerHTML: _text}});
        }
        if(this.hostingName === 'Springer') {
            return h(MathJax, {props: {text: _text, inlineMath: [['\\(', '\\)'],['$', '$']], displayMath: [['$$', '$$']]}});
        }
        return h(MathJax, {props: {text: _text}});
    }
});
